import { Injectable, signal } from '@angular/core';
import { EndPoint } from '@constants/api.constant';
import { IResponse, Page } from '@models/common.model';
import { NutriSearchQuery, NutrishopProfile } from '@models/nutrishop.model';
import { BaseService } from './base.service';
import { finalize, tap } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class NutrishopService extends BaseService {
  private _loading = signal(false);
  private _profile = signal({} as NutrishopProfile);

  get loading() {
    return this._loading.asReadonly();
  }

  get profile() {
    return this._profile.asReadonly();
  }

  loadProfile(id: number = 0) {
    this._loading.set(true);
    let url = `${EndPoint['nutrishopProfile'].path}/${id}`;
    if (!id) {
      url = EndPoint['nutrishopMe'].path;
    }
    this.http.get<IResponse<NutrishopProfile>>(url).subscribe({
      next: res => {
        this._profile.set(res.data);
      },
      complete: () => this._loading.set(false),
    });
  }

  updateProfile(data: Partial<NutrishopProfile>) {
    this._loading.set(true);
    const profile = this._profile();
    return this.http
      .put<IResponse<NutrishopProfile>>(EndPoint['nutrishopProfile'].path, {
        ...profile,
        ...data,
        nutrishopId: profile.id,
      })
      .pipe(
        tap(() => this._loading.set(true)),
        finalize(() => {
          this._loading.set(false);
          this.loadProfile();
        })
      );
  }

  search(params: NutriSearchQuery) {
    return this.http.get<IResponse<Page<NutrishopProfile>>>(
      EndPoint['searchNutridayShop'].path,
      { params }
    );
  }
}
